// Request context automatico per gli eventi. Nel browser la "richiesta" è la
// pagina corrente: URL (senza query, salvo sendPii), User-Agent e referrer.
// Su Node non c'è una richiesta implicita → `undefined` (usare
// `scope.setRequest` nei server, es. da un middleware).

import { isBrowser } from './runtime'

export function autoRequestContext(
  sendPii: boolean,
): Record<string, unknown> | undefined {
  if (!isBrowser()) return undefined

  const request: Record<string, unknown> = {
    url: sendPii ? location.href : location.origin + location.pathname,
    headers: { 'User-Agent': navigator.userAgent },
  }
  const referrer = typeof document !== 'undefined' ? document.referrer : ''
  if (referrer) {
    request['referrer'] = sendPii ? referrer : stripQuery(referrer)
  }
  return request
}

function stripQuery(href: string): string {
  try {
    const url = new URL(href)
    return url.origin + url.pathname
  } catch {
    return (href.split('?')[0] ?? href).split('#')[0] ?? href
  }
}
